import react, { useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";

import './Home.css';

const HomeScreen = () => {
    const navigate = useNavigate();
    useEffect(() => {
        navigate(`/signup`);
    }, [])
    

    return (
        <div>
            <h1>Home</h1>

        </div>
    )
}

export default HomeScreen;